export class GameClock {
  readonly stepSeconds: number;
  private accumulator = 0;
  private lastTime?: number;

  constructor(fixedUpdatesPerSecond = 60) {
    this.stepSeconds = 1 / fixedUpdatesPerSecond;
  }

  reset(nowMilliseconds?: number): void {
    this.accumulator = 0;
    this.lastTime = nowMilliseconds;
  }

  tick(nowMilliseconds: number, update: (stepSeconds: number) => void): number {
    if (this.lastTime === undefined) {
      this.lastTime = nowMilliseconds;
      return 0;
    }

    const frameSeconds = Math.min((nowMilliseconds - this.lastTime) / 1000, 0.25);
    this.lastTime = nowMilliseconds;
    this.accumulator += Math.max(0, frameSeconds);

    let ticks = 0;
    while (this.accumulator >= this.stepSeconds) {
      update(this.stepSeconds);
      this.accumulator -= this.stepSeconds;
      ticks += 1;
    }
    return ticks;
  }
}
